// src/pages/CasinoViewRouter.jsx
import React from 'react';
import { useParams } from 'react-router-dom';
import CasinoTeenPattiViewPage from './CasinoTeenPattiViewPage';
import CasinoTeenPattiOneDayViewPage from './CasinoTeenPattiOneDayViewPage';
import CasinoLucky7ViewPage from './CasinoLucky7ViewPage';
import CasinoDragonTigerViewPage from './CasinoDragonTigerViewPage';
import CasinoDragonTiger2ViewPage from './CasinoDragonTiger2ViewPage';
import CasinoAndarBaharViewPage from './CasinoAndarBaharViewPage';
import CasinoAAAViewPage from './CasinoAAAViewPage';
// Import other game view pages...

const CasinoViewRouter = () => {
  const { tableId, gameName } = useParams();

  const decodedGameName = decodeURIComponent(gameName || '');
  const normalizedGameName = decodedGameName.toLowerCase().replace(/\s+/g, '');

  switch(normalizedGameName) {
    case 'teenpatti':
      console.log('Rendering TeenPatti');
      return <CasinoTeenPattiViewPage />;
    
    case 'teenpattioneday':
    case 'teenpattionday':
      console.log('Rendering TeenPatti OneDay');
      return <CasinoTeenPattiOneDayViewPage />;
    
    case 'lcuky7a':
      console.log('Rendering Lucky 7A');
      return <CasinoLucky7ViewPage />;
    
    case 'dragontiger':
      console.log('Rendering Dragon Tiger');
      return <CasinoDragonTigerViewPage />;
    
    case 'dragontiger2':
      console.log('Rendering Dragon Tiger 2');
      return <CasinoDragonTiger2ViewPage />;
    
    case 'andarbahar':
      console.log('Rendering Andar Bahar');
      return <CasinoAndarBaharViewPage />;
    
    case 'amaralbaranthony':
    case 'aaa':
      console.log('Rendering Amar Albar Anthony (AAA)');
      return <CasinoAAAViewPage />;
    
    default:
      console.warn('Unknown game - Going to default:', normalizedGameName);
      return (
        <div className="p-8 text-center">
          <h2 className="text-xl font-bold mb-4">Game Not Found</h2>
          <p className="text-gray-600 mb-2">Game: {decodedGameName}</p>
          <p className="text-gray-600 mb-2">Normalized: {normalizedGameName}</p>
          <p className="text-gray-600">Table ID: {tableId}</p>
          <button 
            onClick={() => window.history.back()}
            className="mt-4 bg-blue-500 text-white px-4 py-2 rounded"
          >
            Go Back
          </button>
        </div>
      );
  }
};

export default CasinoViewRouter;